<script>
/**
 * Footer component
 */
export default {
  name: "Footer"
};
</script>

<template>
  <div>
    <!--START FOOTER ALTER-->
    <div class="footer-alt">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="float-left pull-none">
              <p class="copy-rights text-muted mb-3 mb-sm-0">
                {{ new Date().getFullYear() }} © Apptime. All rights reserved.
              </p>
            </div>
            <div class="float-right pull-none">
              <ul class="list-inline social m-0">
                <li class="list-inline-item">
                  <a
                    href="https://www.facebook.com/apptimegr"
                    target="_blank"
                    class="social-icon"
                  >
                    <i class="mdi mdi-facebook"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a
                    href="https://twitter.com/mi_agg"
                    target="_blank"
                    class="social-icon"
                  >
                    <i class="mdi mdi-twitter"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <!--START FOOTER ALTER-->
  </div>
</template>